export function data() {
  return {
    settingFilters: false,
    dependents: {
      fornecedor: ['produto', 'sub_produto', 'cliente', 'transportadora'],
    },
    gates: [],
    params: {
      data_cancelado_inicio: {
        value: '',
        visible: false,
      },
      data_cancelado_fim: {
        value: '',
        visible: false,
        until: true,
      },
      gate: {
        value: '',
        visible: false,
        // get: () => { },
      },
      proprietario: {
        value: '',
        visible: false,
        // get: () => { },
      },
      fornecedor: {
        value: '',
        visible: false,
        get: this.getFornecedores,
      },
      produto: {
        value: '',
        visible: false,
      },
      sub_produto: {
        value: '',
        visible: false,
      },
      cliente: {
        value: '',
        visible: false,
        get: this.getClientes,
      },
      transportadora: {
        value: '',
        visible: false,
        get: this.getTransportadoras,
      },
      terminal: {
        value: '',
        visible: false,
        get: this.getContratos,
      },
      regiao: {
        value: '',
        visible: false,
        get: this.getRegioes,
      },
      representante: {
        value: '',
        visible: false,
        get: this.getRepresentantes,
      },
      motorista: {
        value: '',
        visible: false,
        get: this.getMotoristas,
      },
      placa_cavalo: {
        value: '',
        visible: false,
      },
      eixo: {
        value: '',
        visible: false,
      },
    },
    allOptions: [
      'data_cancelado_inicio',
      'data_cancelado_fim',
      'gate',
      'proprietario',
      'fornecedor',
      'produto',
      'sub_produto',
      'cliente',
      'transportadora',
      'terminal',
      'regiao',
      'representante',
      'motorista',
      'placa_cavalo',
      'eixo',
    ],
  }
}
